import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { t } from 'i18next';
import { PiNavigationArrow, PiPlus, PiTrash } from 'react-icons/pi';
import { IClientAccountForm } from 'services/client-account/types';
import { useGetClientUsersLightList } from 'services/clientUserManagment';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ClientAccountUsers = () => {
  const clientUsers = useGetClientUsersLightList();

  const { values, setFieldValue, status, initialStatus } =
    useFormikContext<IClientAccountForm>();

  const navigateToNewWindow = useNewWindowNavigate();

  const clientUsersOptions = (users: string[]) =>
    clientUsers.data
      ?.filter(user => !users.includes(user.id))
      .map(user => ({
        label: user.userName,
        value: user.id,
      })) ?? [];

  const goToClientUser = (id: string) => {
    window.open(`/client-users/${id}/accounts`, '_blank');
  };

  return (
    <Table
      displayMode
      data={{
        nodes: values.users.map((user, key) => ({
          id: key,
          value: user.id,
          label: user.name,
        })),
      }}
      columns={[
        {
          label: t('input.label.client-user'),
          renderCell: ({ label, value, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={label} />
              ) : (
                <FormInput.Select
                  name={`users[${id}].id`}
                  label={t('input.label.client-user')}
                  options={clientUsersOptions(
                    values.users.map(user => user.id)
                  )}
                  onChange={option => {
                    setFieldValue(`users[${id}].id`, option.value);
                    setFieldValue(`users[${id}].name`, option.label);
                  }}
                  value={{ label: label ?? '-', value: value }}
                />
              )}
            </TableItem>
          ),
        },

        {
          label: '',
          renderCell: ({ value }) => (
            <TableItem justifyPosition='end'>
              {status?.displayMode ? (
                <Button isClear onlyIcon onClick={() => goToClientUser(value)}>
                  <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              ) : (
                <Button
                  variant={BUTTON_VARIANT.remove}
                  isClear
                  onlyIcon
                  onClick={() =>
                    setFieldValue(
                      `users`,
                      values.users.filter(user => user.id !== value)
                    )
                  }>
                  <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </TableItem>
          ),
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    disable={
                      values.users.length
                        ? !values.users[values.users.length - 1]?.id.length
                        : false
                    }
                    onClick={() =>
                      setFieldValue(`users[${values.users?.length ?? 0}]`, {
                        id: '',
                        name: '',
                      })
                    }>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
      size='compact'
    />
  );
};

export default ClientAccountUsers;
